import { render, staticRenderFns } from "./tarihinput.vue?vue&type=template&id=16127686&"
import script from "./tarihinput.vue?vue&type=script&lang=js&"
export * from "./tarihinput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports